import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListPushCampaignsV1Response } from './list-push-campaigns-v1-response';
import { listPushCampaignsV1ResponseSchema } from './list-push-campaigns-v1-response';

export async function listPushCampaignsV1Api(
  params?: { cursor?: string; limit?: number },
  options?: IRequestOptions,
): Promise<IValidatedResponse<IListPushCampaignsV1Response>> {
  const search = new URLSearchParams();
  if (params?.cursor) {
    search.set('cursor', params.cursor);
  }
  if (params?.limit) {
    search.set('limit', String(params.limit));
  }
  const qs = search.toString();

  return getRequest<IListPushCampaignsV1Response>({
    path: `/sys/notifications/v1/campaigns${qs ? `?${qs}` : ''}`,
    schema: listPushCampaignsV1ResponseSchema,
    options,
  });
}
